var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.forms.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("nav.forms"),
            icon: "clipboard-list",
            count: _vm.forms.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/forms")
            }
          }
        },
        _vm._l(_vm.visibleForms, function(form) {
          return _c(
            "button",
            {
              key: form.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openRequest(form)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [_vm._v(_vm._s(form.name))]),
                _c("small", [
                  _vm._v(
                    _vm._s(
                      _vm.DateTime.fromISO(form.sentTimestamp).toLocaleString(
                        _vm.DateTime.DATETIME_SHORT
                      )
                    )
                  )
                ])
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }